import React from 'react';
import { useEffect, useState, useRef, createContext } from 'react';
import axios from 'axios';
import Button from './Button';
import Product from './Product';
import Loading from './Loading';
import Step from './Step';
import CollectionOption from './CollectionOptions';
import SizeOption from './SizeOption';
import ColorOption from './ColorOption';
import DesignOption from './DesignOption';
import DisplayIncludedProduct from './DisplayIncludedProduct';
import { parseNumberList } from './SizeOption';
import DesignSubmissionForm from './DesignSubmissionForm';
import UploadCSV from './UploadCSV';
import { ArrowRight } from 'react-bootstrap-icons';
import { ArrowLeft } from 'react-bootstrap-icons';

export const availableSteps = [
  {
    step: 1,
    heading: 'Select the jersey style',
  },
  {
    step: 2,
    heading: 'Select the color',
  },
  {
    step: 3,
    heading: 'Select Design',
  },
  {
    step: 4,
    heading: 'Set Names And Numbers',
  },
  {
    step: 5,
    heading: 'Confirm Names And Numbers',
  },
  {
    step: 7,
    heading: 'Confirm Products',
  },
];

export const PracticeJerseyOrderContext = createContext();

const PracticeJerseyOrder = (props) => {
  //data for the app
  const [collectionData, setCollectionData] = useState(false); //store selected collection for the order to add numbers to
  const [products, setProducts] = useState([]); //store selected products for the order to add numbers to
  const [hasDesigns, setHasDesigns] = useState(false); //if the customer has not submitted designs yet.
  const [availableDesigns, setAvailableDesigns] = useState([]); //store selected products for the order to add numbers to

  //data for the order
  const [includedProducts, setIncludedProducts] = useState([]); //store selected products for the order to add numbers to
  const [designs, setDesigns] = useState([]); //store selected designs for the order to add numbers to
  const [allowedDesigns, setAllowedDesigns] = useState(false); //store selected designs for the order to add numbers to
  const [selectedDesigns, setSelectedDesigns] = useState([]); //store selected design for the order to add numbers to
  const [selectedProduct, setSelectedProduct] = useState(''); //store selected product for the order to add numbers to
  const [selectedCollection, setSelectedCollection] = useState(''); //store selected collection for the order to add numbers to

  const [productData, setProductData] = useState([]); //Store specific size, qty, number, and name data for the order

  const [step, setStep] = useState(1); //store selected collection for the order to add numbers to
  const [loading, setLoading] = useState(false); //store selected collection for the order to add numbers to

  const [sizeData, setSizeData] = useState([]); //store selected collection for the order to add numbers to

  const autoSequenceRef = useRef(null);
  const includeNamesRef = useRef(null);
  const startNumberRef = useRef(null);
  const includeNumbersRef = useRef(null);

  // Use state to manage the values for controlled components.
  const [autoSequence, setAutoSequence] = useState(true);
  const [includeNames, setIncludeNames] = useState(false);
  const [startNumber, setStartNumber] = useState(1);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [designSearchVal, setDesignSearch] = useState('');
  const [startDesigns, setStartDesigns] = useState(0);
  const [endDesigns, setEndDesigns] = useState(4);
  const increment = 4;

  const designSearch = useRef(null);
  const loadProductNames = useRef(null);

  const handleLoadNames = () => {
    let product = loadProductNames.current.value;
    let productToEdit = includedProducts.find((item) => item.product.title === product);
    setSizeData(productToEdit.sizeData);
  };

  const handleDesignSearch = (e) => {
    setDesignSearch(e.target.value);
    setStartDesigns(0);
    setEndDesigns(4);
  };

  const nextDesign = () => {
    setStartDesigns(startDesigns + increment);
    setEndDesigns(endDesigns + increment);
  };

  const prevDesign = () => {
    setStartDesigns(startDesigns - increment);
    setEndDesigns(endDesigns - increment);
  };

  const designFilter = (design) => {
    if (designSearchVal.length > 0) {
      return design.title.toLowerCase().includes(designSearchVal.toLowerCase());
    }
    return true;
  };

  const [sizes, setSizes] = useState([]);

  const jerseyCollections = [
    {
      title: 'Regular',
      handle: 'custom-reversible-practice-jerseys',
    },
    {
      title: 'Reverse',
      handle: 'custom-gamewear-two-toned-practice-jerseys',
    },
    {
      handle: 'custom-house-league-practice-jerseys',
    },
    {
      title: 'Special',
      handle: 'custom-practice-jerseys',
    },
  ];
  //Api Calls

  const addToCart = (items) => {
    axios
      .post(
        '/cart/add.js',
        {
          items,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        console.log('CART', response.data);
        //sent to /cart
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.log('ERROR', error);
        getCart();
      });
  };

  const getCart = () => {
    axios
      .get('/cart.json')
      .then((response) => {
        console.log('CART', response.data);
      })
      .catch((error) => {
        console.log('ERROR', error);
      });
  };

  const getProduct = (product) => {
    return axios.get(`/products/${product}.json`);
  };

  const getCollectionProducts = (collection) => {
    setStep(2);
    setLoading(true);
    axios
      .get(`/collections/${collection}/products.json`)
      .then((response) => {
        console.log('COLLECTION', response);
        if (response.data.products.length > 0) {
          setProducts(response.data.products);
          setSelectedProduct(response.data.products[0]);
        }
      })
      .catch((error) => {
        console.log('ERROR', error);
      });
  };

  const getCollectionData = async (collection) => {
    try {
      const data = await axios.get(`/collections/${collection}.json`);
      return data.data.collection;
    } catch (error) {
      console.log('ERROR', error);
    }
  };

  //process functions

  const loadCollections = async () => {
    if (!collectionData) {
      let storeCollectionData = [];
      for (const item of jerseyCollections) {
        let data = await getCollectionData(item.handle);
        storeCollectionData.push({ ...item, ...data });
      }
      setCollectionData(storeCollectionData);
    }
  };

  const addIncludedProduct = (product, designs, collection, sizeData) => {
    setIncludedProducts([...includedProducts, { product, designs, collection, sizeData }]);
  };

  const namesAndNumbersValid = () => {
    //make sure the names and numbers are valid
    return true;
  };

  ///handle functions

  const handleSetSize = (size, qty, sizeNumbers = [], sizeNames = []) => {
    console.log('SET SIZE', size, qty);
    let newSizeData = { size, qty, sizeNumbers, sizeNames };
    let newSizes = [];

    if (size) {
      let replaceSize = sizeData.find((item) => item.size === size);
      let replaceName = sizeData.find((item) => item.size === size);

      if (replaceSize) {
        newSizes = sizeData.filter((item) => item.size !== size);
        newSizes.push(newSizeData);
      } else {
        newSizes = [...sizeData, newSizeData];
      }
    } else {
      newSizes = sizeData;
    }
    if (autoSequence) {
      console.log('AUTO SEQUENCE', autoSequence, startNumber, sizeNumbers);
      let currNumber = parseInt(startNumber);
      sizes.map((size) => {
        let thisSizeIdx = newSizes.findIndex((item) => item.size === size);
        if (thisSizeIdx >= 0) {
          newSizes[thisSizeIdx].sizeNumbers =
            newSizes[thisSizeIdx].qty > 1
              ? parseNumberList(`${currNumber}-${parseInt(currNumber) + parseInt(newSizes[thisSizeIdx].qty - 1)}`)
              : [currNumber];
          currNumber += parseInt(newSizes[thisSizeIdx].qty);
        }
      });
    }
    console.log('NEW SIZES', newSizes);
    setSizeData([...newSizes]);
    return 'done';
  };

  const handleAddToCart = () => {
    let newItems = [];

    for (const item of includedProducts) {
        console.log('ITEM', item);
      let product = item.product;
      let designs = item.designs;
      let collection = item.collection;
      let sizeData = item.sizeData;
      let totalSizes = sizeData.reduce((acc, item) => acc + parseInt(item.qty), 0);
      for (const curr of sizeData) {
        let sizeName = curr.size;
        console.log('VARAINTS', product.variants, sizeName);
        let variant = product.variants.find((item) => item.option2 === sizeName);
        if (!variant) {
          continue;
        }
        let newVariant = {
          id: variant.id,
          quantity: curr.qty,
          properties: {
            design: designs.map((item) => `${item.title} - ${item.location}`).join(', '),
            collection: collection.title,
            numbers: curr.sizeNumbers.join(', '),
          },
        };
        if (includeNames) {
          newVariant.properties.names = curr.sizeNames.join(', ');
        }
        newItems.push(newVariant);
      }
      designs.map((design) => {
        let newVariant = {
          id: design.variant_id,
          quantity: totalSizes,
          properties: {
            collection: collection.title,
            product: product.title,
          },
        };
        newItems.push(newVariant);
      });
    }
    console.log('NEW ITEMS', newItems);
    addToCart(newItems);
  };

  const handleIncludeNumbersChange = () => {
    setIncludeNumbers(!includeNumbers);
  };

  const handleAutoSequenceChange = () => {
    setAutoSequence(!autoSequence);
  };

  const handleIncludeNamesChange = () => {
    setIncludeNames(!includeNames);
  };

  const handleStartNumberChange = (e) => {
    if (e.target.value < 0 || e.target.value > 99) {
      return;
    }
    console.log('START NUMBER', e.target.value);
    setStartNumber(e.target.value);
  };

  const handleConfirmNames = () => {
    if (namesAndNumbersValid()) {
      let thisProduct = {
        product: selectedProduct,
        designs: selectedDesigns,
        collection: selectedCollection,
        sizeData: sizeData,
      };
      addIncludedProduct(thisProduct.product, thisProduct.designs, thisProduct.collection, thisProduct.sizeData);
      setSelectedCollection(false);
      setSelectedProduct(false);
      setSelectedDesigns([]);
      setSizeData([]);
      goStep(6);
    }
  };

  const handleConfirmedProducts = () => {
    handleAddAnotherProduct(null, true);
  };

  const handleEditProduct = (index) => {
    if (index === 'current') {
      goStep(1);
    } else {
      let currProduct = { product: selectedProduct, designs: selectedDesigns, collection: selectedCollection };
      let productToEdit = { ...includedProducts[index] };
      console.log('EDIT PRODUCT', productToEdit, currProduct, index);
      let newProducts = includedProducts.filter((item, i) => i !== index);
      newProducts.push(currProduct);
      setIncludedProducts(newProducts);
      setSelectedCollection(productToEdit.collection);
      setSelectedProduct(productToEdit.product);
      setSelectedDesigns(productToEdit.designs);
      setSizeData(productToEdit.sizeData);
      goStep(1);
    }
  };

  const handleAddAnotherProduct = (e, confirming = false) => {
    if (confirming) {
      goNext(confirming);
    } else {
      goStep(1);
    }
  };

  const handleSetCollection = (collection) => {
    setSelectedCollection(collection.handle);
    getCollectionProducts(collection.handle);
  };

  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    console.log(product);
  };

  const handleSelectedDesigns = (product, variant, isSelected) => {
    //if its selected add it to the list if not already there
    let newDesigns = [];
    if (isSelected) {
      newDesigns = [
        ...selectedDesigns,
        {
          handle: product.handle,
          location: variant.title,
          title: product.title,
          image: product.images[0].src,
          price: variant.price,
          variant_id: variant.id,
        },
      ];
    } else {
      newDesigns = selectedDesigns.filter((item) => item.handle !== product.handle);
    }
    setSelectedDesigns(newDesigns);
  };

  const resetHasDesigns = () => {
    setHasDesigns(false);
  };

  const canChangeSteps = (newStep) => {
    //make sure the step is ready to be moved to

    switch (newStep) {
      case 1:
        return true;
      case 2:
        return selectedCollection ? true : false;
      case 3:
        return selectedProduct ? true : false;
      case 4:
        return selectedProduct && selectedDesigns ? true : false;
      case 5:
        return sizeData > 0 ? true : false;
      case 6:
        return namesAndNumbersValid ? true : false;
      case 7:
        return includedProducts.length > 0 ? true : false;
      case 8:
        return includedProducts.length > 0 ? true : false;
      default:
        return false;
    }
  };

  const goNext = (confirmed) => {
    if (confirmed) {
      setStep(step + 1);
    } else goStep(step + 1);
  };

  const goPrev = () => {
    goStep(step - 1);
  };

  const goStep = (newStep) => {
    if (canChangeSteps(newStep)) {
      setStep(newStep);
    }
  };

  const getAvailableDesigns = () => {
    const element = document.getElementById('AllowedDesigns');
    const handles = [];

    if (element) {
      // Select all child elements with the class 'available-design'
      const items = element.querySelectorAll('.available-design');

      // Iterate over the items and extract the 'data-handle' attribute
      items.forEach((item) => {
        const handle = item.getAttribute('data-handle');
        if (handle) {
          handles.push(handle);
        }
      });
    }
    //for each of the handles fetch the product data
    const products = [];
    handles.forEach((handle) => {
      getProduct(handle).then((response) => {
        products.push(response.data.product);
      });
    });
    setAvailableDesigns(products);
  };

  //use effects

  useEffect(() => {
    //load initial collection data based on the collections in the json
    if (!collectionData) {
      loadCollections();
    } else {
      getCollectionProducts(selectedCollection);
    }

    if (!allowedDesigns) {
      getAvailableDesigns();
    }
  }, []);

  useEffect(() => {
    console.log('STEP', step);
    //move to that step in the window
    let stepEl = document.getElementById('step' + step);
    if (stepEl) {
      //leave a 100px buffer at top of window
      //ease the scroll to the step

      setTimeout(() => {
        let top = stepEl.offsetTop - 120;
        window.scrollTo({
          top: top,
          left: 0,
          behavior: 'smooth',
        });
      }, 100);
    }
  }, [step]);

  useEffect(() => {
    if (selectedProduct.options) {
      let thisProductSizes = selectedProduct.options.find((item) => item.name === 'Size').values;
      setSizes(thisProductSizes);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (autoSequence) {
      handleSetSize(false, false);
    }
  }, [startNumber]);

  const isDesignSelected = (design) => {
    return selectedDesigns.findIndex((item) => item.handle === design.handle) >= 0;
  };

  const Totals = () => {
    if (!selectedProduct) {
      return <div></div>;
    }

    return (
      <div className="totals">
        <h2 className="Heading">Totals</h2>
        <div className="d-flex flex-md-row w-100">
          <div className="jerseys">
            <div className="info">
              <b>Total Jerseys</b>
              <span>{sizeData.reduce((acc, item) => acc + parseInt(item.qty), 0)}</span>
            </div>
            <div className="info">
              <b>Total Designs</b>
              <span>{selectedDesigns.length}</span>
            </div>
          </div>
          <div className="pricing">
            <div className="info">
              <b>Price Per Jersey</b>
              <span>${selectedProduct?.variants[0]?.price || 'N/A'}</span>
            </div>
            <div className="info">
              <b>Designs Price Per Jersey</b>
              <span>${selectedDesigns.reduce((acc, item) => acc + parseInt(item.price), 0)}</span>
            </div>
            <div className="info">
              <b>Total Price</b>
              <span>
                $
                {sizeData.reduce((acc, item) => acc + parseInt(item.qty), 0) *
                  (parseFloat(selectedProduct?.variants[0]?.price) +
                    parseFloat(selectedDesigns.reduce((acc, item) => acc + parseInt(item.price), 0)))}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (!hasDesigns) {
    return (
      <div className={`step`} id={'step' + step}>
        <div className="step-header d-flex w-100 align-items-center m-auto flex-column">
          <h1 className={`Heading text-center m-auto`}>Have you submitted your designs already</h1>
        </div>
        <div className={`step-info flex-column align-items-center text-center`}>
          <p>
            If you have not already submitted the desired designs for approval and pricing please click the "no" button
            below to submit your designs.
          </p>
          <div className="d-flex">
            <Button className="ml-auto" onClick={() => setHasDesigns('yes')}>
              Yes
            </Button>
            <Button className="ml-2" onClick={() => setHasDesigns('no')}>
              No{' '}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (hasDesigns == 'no') {
    return <DesignSubmissionForm resetHasDesigns={resetHasDesigns} />;
  }

  return (
    <PracticeJerseyOrderContext.Provider
      value={{ selectedCollection, selectedDesigns, selectedProduct, sizeData, collectionData, includedProducts }}
    >
      <Step step={1} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(1)}>
        {collectionData ? (
          collectionData.map((item, index) => {
            return <CollectionOption collection={item} handleSetCollection={handleSetCollection} />;
          })
        ) : (
          <Loading />
        )}
      </Step>
      <Step step={2} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(2)}>
        <div className="d-lg-flex">
          <div className="text-center w-50">
            {selectedProduct ? (
              <Product product={selectedProduct} handleSelectProduct={handleSelectProduct} />
            ) : (
              <div>Please select a Product color</div>
            )}
          </div>
          <div className="d-block color-options">
            <div className="w-100 Heading">
              <b>Color Options</b>
            </div>
            <p>Please select a color from the below options.</p>
            <div className="d-flex flex-wrap">
              {products?.map((item, index) => {
                return <ColorOption product={item} handleSetColor={handleSelectProduct} currColor={selectedProduct} />;
              }) || ''}
            </div>
          </div>
        </div>
        <div className="w-100 buttons">
          <Button className="ml-auto" onClick={goNext}>
            Next{' '}
          </Button>
        </div>
      </Step>
      <Step step={3} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(3)}>
        <div className="design-option-list">
          <b className="Heading">Design Options</b>
          <p>
            Please select the Design or designs desired from the below options, ensure to select the correct position
            from the drop down.
          </p>
          <div className="search mb-2">
            <input type="text" placeholder="Search Designs" ref={designSearch} onChange={handleDesignSearch} />
          </div>
          <div className="d-flex flex-wrap">
            {availableDesigns
              ?.slice(startDesigns, endDesigns)
              .filter(designFilter)
              .map((item, index) => {
                return (
                  <DesignOption
                    key={item.id}
                    design={item}
                    handleSetDesign={handleSelectedDesigns}
                    currColor={selectedProduct}
                    selectedDesigns={selectedDesigns}
                  />
                );
              }) || <Loading />}
          </div>
          <div className="d-flex d-wrap pagination">
            <Button
              className={`ml-0 ${startDesigns <= 0 ? 'disabled' : ''}`}
              onClick={prevDesign}
              disabled={startDesigns <= 0}
            >
              <ArrowLeft />{' '}
            </Button>
            <Button
              className={`ml-2 ${endDesigns >= availableDesigns?.length ? 'disabled' : ''}`}
              onClick={nextDesign}
              disabled={endDesigns >= availableDesigns?.length}
            >
              <ArrowRight />{' '}
            </Button>
          </div>
        </div>
        <div className="w-100 buttons">
          <Button className="ml-auto" onClick={goNext}>
            Next{' '}
          </Button>
        </div>
      </Step>
      <Step step={4} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(4)}>
        {includedProducts.length > 0 && (
          <div className="included-products">
            <b className="Heading">Copy from previous products</b>
            <select name="" id="" ref={loadProductNames}>
              {includedProducts.map((item, index) => {
                return (
                  <option value={item.product.title} key={item.product.title + index}>
                    {item.product.title}
                  </option>
                );
              })}
            </select>
            <Button className="Button" onClick={handleLoadNames}>
              Load Names
            </Button>
          </div>
        )}
        <div className="upload-csv">
          <div className="Heading">Use a CSV File</div>
          <p>
            Export a CSV file from your spreadsheet program with the first column being the size, second the number, and
            third the name. Then click the button below to upload the file. Or you can manually enter the numbers and
            names below. You can also edit the names and numbers after uploading the csv.{' '}
            <a href="https://cdn.shopify.com/s/files/1/0709/2138/8344/files/practice-jersey-csv-example.csv">
              Click here to download an example.
            </a>{' '}
            If you want to enter manually please scroll down. You can Edit or Add names and numbers after they have been
            uploaded as well.
          </p>
          <UploadCSV
            sizes={sizes}
            setIncludeNames={setIncludeNames}
            setAutoSequence={setAutoSequence}
            setSizeData={setSizeData}
          />
          <b>Available Size Options For Selected Product</b>
          <div className="d-flex flex-wrap">
            {sizes.map((item, index) => {
              return (
                <div className="size" key={item + index}>
                  {item}
                </div>
              );
            })}
          </div>
          <p>please only use these as the size options for best results</p>
        </div>
        <div className="options manual-options align-start" style={{ paddingRight: '15px' }}>
          <div className="Heading title m-auto text-center w-100">Manual Entry Options</div>
          <p>For best results enter your correct QTY's per size before entering your numbers and names.</p>
          <div className="box">
            <input
              type="checkbox"
              id="includeNumbers"
              name="includeNumbers"
              checked={includeNumbers}
              onChange={handleIncludeNumbersChange}
              ref={includeNumbersRef}
            />
            <div className="d-flex flex-column text-left w-100">
              <label htmlFor="includeNumbers">Include Numbers</label>
              <span>Numbers will be printed according to the design you selected per uniform</span>
            </div>
          </div>
          <div className="box">
            <input
              type="checkbox"
              id="autoSequence"
              name="autoSequence"
              checked={autoSequence}
              onChange={handleAutoSequenceChange}
              ref={autoSequenceRef}
            />
            <div className="d-flex flex-column text-left">
              <label htmlFor="autoSequence">Auto-Sequence</label>
              <span>
                If auto sequence is on it will number them in order from smallest to largest starting with the entered
                start number
              </span>
            </div>
          </div>
          {autoSequence && (
            <div className="box flex-column align-start">
              <label htmlFor="startNumber" className="">
                Start Number:
              </label>
              <input
                type="number"
                id="startNumber"
                name="startNumber"
                min="0"
                max="99"
                value={startNumber}
                onChange={handleStartNumberChange}
                ref={startNumberRef}
              />
            </div>
          )}
          <div className="box">
            <input
              type="checkbox"
              id="includeNames"
              name="includeNames"
              checked={includeNames}
              onChange={handleIncludeNamesChange}
              ref={includeNamesRef}
            />
            <div className="d-flex flex-column text-left w-100">
              <label htmlFor="includeNames">Include Names</label>
              Including names will add names according to your design per uniform
            </div>
          </div>
        </div>
        <Totals />
        <div className="sizes">
          {sizes.map((item, index) => {
            return (
              <SizeOption
                size={item}
                autoSequence={autoSequence}
                includeNames={includeNames}
                startNumber={startNumber}
                includeNumbers={includeNumbers}
                handleSetSize={handleSetSize}
                sizeData={sizeData}
                productNum={includedProducts.length}
              />
            );
          })}
        </div>
        <Totals />
        <div className="w-100 buttons">
          <Button className="ml-auto" onClick={goNext}>
            Next{' '}
          </Button>
        </div>
      </Step>
      <Step step={5} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(5)}>
        <div className="display-sizes-names">
          <div className="Heading">Selected Sizes, Numbers, And Names</div>
          <div className="d-flex w-100">
            <div className="size-names">
              {sizeData &&
                sizeData.length > 0 &&
                sizeData
                  .filter((x) => x.qty > 0)
                  .map((item, index) => {
                    return (
                      <div className="size-name" key={item.size + index}>
                        <div className="size">
                          <b>Size</b>
                          <span>{item.size}</span>
                        </div>
                        <div className="qty">
                          <b>Qty</b>
                          <span>{item.qty}</span>
                        </div>
                        {includeNames && item.sizeNames?.length > 0 && (
                          <div className="names">
                            <b>Names</b>
                            <span>{item.sizeNames ? item.sizeNames.join(', ') : 'None'}</span>
                          </div>
                        )}
                        <div className="numbers">
                          <b>Numbers</b>
                          <span>{item.sizeNumbers ? item.sizeNumbers.join(', ') : 'None'}</span>
                        </div>
                        {includeNames && item.sizeNames?.length > 0 && (
                          <div className="name-numbers">
                            <b>Names And Numbers</b>
                            <span>
                              {item.sizeNumbers &&
                                item.sizeNumbers.length > 0 &&
                                item.sizeNumbers.map((number, i) => {
                                  return (
                                    <div key={item.size + i} className="d-flex name-number">
                                      <span>{number}</span>
                                      <span>{includeNames && item.sizeNames ? item.sizeNames[i] : ''}</span>
                                    </div>
                                  );
                                })}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>

        <Totals />
        <div className="w-100 buttons">
          <Button className="ml-auto" onClick={goPrev}>
            Edit Names{' '}
          </Button>

          <Button className="ml-2" onClick={handleConfirmNames}>
            Confirm Sizes And Information{' '}
          </Button>
        </div>
      </Step>
      <Step step={6} setStep={goStep} currStep={step} loading={loading} available={canChangeSteps(6)}>
        {
          <>
            {includedProducts &&
              includedProducts.length > 0 &&
              includedProducts.map((item, index) => {
                return <DisplayIncludedProduct {...item} handleEditProduct={handleEditProduct} index={index} />;
              })}
          </>
        }
        <div className="w-100 buttons">
          <Button className="ml-auto" onClick={handleAddAnotherProduct}>
            Add Another
          </Button>
          <Button className="ml-2" onClick={handleAddToCart}>
            Confirm Products & Add To Cart
          </Button>
        </div>
      </Step>
    </PracticeJerseyOrderContext.Provider>
  );
};

export default PracticeJerseyOrder;
